// extracted by mini-css-extract-plugin
export default {"wrap":"ProductManagementBanner_wrap__n9S70","img":"ProductManagementBanner_img__yLNc3"};